import $ from 'jquery';
import _filter from 'lodash/_baseFilter.js';

export const components = {};

export default class Page {
  constructor(element, selector = '') {
    this.selector = selector;
    this.name = this.constructor.name;

    this.$ = {
      window: $(window),
      document: $(document),
      body: $('.js-body'),
      page: $('.js-page'),
      root: $(element)
    };

    if (this.$.root.length) {
      this.init();
      this.events();
    }
  }
  init() {
    console.warn(`Need create init method for "${this.selector}"`);
  }
  elements(elements) {
    for (let element in elements) {
      this.$[element] = this.$.root.find(elements[element]);
    }
  }
  events() {
    // no events
  }
  bodyOverflowEnable() {
    this.$.body.css({ paddingRight: this.getScrollbarWidth() });
    this.$.body.addClass('is-overflow');
  }
  bodyOverflowDisable() {
    this.$.body.removeAttr('style');
    this.$.body.removeClass('is-overflow');
  }
  getScrollbarWidth() {
    return window.innerWidth - this.$.document.width();
  }
  removeRoot() {
    this.$.root.html('').remove();
    delete this.$.root;
  }
  static mount(Constructor, selector) {
    $(selector).map((i, element) => {
      const id = Math.random()
        .toString(16)
        .slice(2);
      // @ts-ignore
      element._selector = selector;
      // @ts-ignore
      element._id = id;
      components[element._id] = new Constructor(element, selector);
    });
  }
  static initComponent(Cons, $node) {
    if (Cons.in($node) || Cons.is($node)) {
      const $element = Cons.is($node) ? $node : Cons.find($node);

      $element.each((i, element) => {
        const id = Math.random()
          .toString(16)
          .slice(2);

        element.selector = Cons.selector;
        element.id = id;

        components[element.id] = new Cons(element, Cons.selector);
      });

      return true;
    } else {
      return false;
    }
  }
  static getAllComponentInstance(name) {
    return _filter(components, component => component.name === name);
  }
}
